import findStep from "./findStep";
import useBotControlStore from "../../../storeModules/useBotControlStore";
import useUserStore from "../../../storeModules/useUserStore";
import { tagPesquisa } from "../../../utils/sendTag";

const researchSteps = [
  {
    name: "inicio_pesquisa",
    sender: "bot",
    text: "Entendi, mas antes de finalizar a nossa conversa, gostaria que respondesse duas perguntas rápidas:",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("pergunta_conhecer_mycon").index,
      });
    },
  },
  {
    name: "pergunta_conhecer_mycon",
    sender: "bot",
    text: "Como você ficou sabendo do <b>Mycon</b>?",
    options: [
      {
        text: "TV",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "TV",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
      {
        text: "FACEBOOK",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "FACEBOOK",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
      {
        text: "INSTAGRAM",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "INSTAGRAM",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
      {
        text: "YOUTUBE",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "YOUTUBE",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
      {
        text: "GOOGLE",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "GOOGLE",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
      {
        text: "E-MAIL",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "E-MAIL",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
      {
        text: "INDICAÇÃO",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "INDICAÇÃO",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
      {
        text: "LIVE",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "LIVE",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
      {
        text: "OUTROS",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              midia: "OUTROS",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_avaliacao_mycon").index,
          });
        },
      },
    ],
  },
  {
    name: "pergunta_avaliacao_mycon",
    sender: "bot",
    text: "De 1 a 5, onde 5 é excelente, qual nota você daria para a experiência de compra no <b>Mycon</b>?",
    options: [
      {
        text: "1",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatcompra: "1",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_ajuda_especialista").index,
          });
        },
      },
      {
        text: "2",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatcompra: "2",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_ajuda_especialista").index,
          });
        },
      },
      {
        text: "3",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatcompra: "3",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_ajuda_especialista").index,
          });
        },
      },
      {
        text: "4",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatcompra: "4",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_ajuda_especialista").index,
          });
        },
      },
      {
        text: "5",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatcompra: "5",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_ajuda_especialista").index,
          });
        },
      },
    ],
  },
  {
    name: "pergunta_ajuda_especialista",
    sender: "bot",
    text: "Antes ou durante a simulação você precisou da ajuda do Time de Especialistas?",
    options: [
      {
        text: "SIM",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              humano: "SIM",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_nota_especialista").index,
          });
        },
      },
      {
        text: "NÃO",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              humano: "NÃO",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pesquisa_finalizada").index,
          });
        },
      },
    ],
  },
  {
    name: "agradecimento_pesquisa",
    sender: "bot",
    text: "Obrigado por avaliar!",
  },
  {
    name: "pesquisa_finalizada",
    sender: "bot",
    text: () => {
      const userBasicName = useUserStore.getState().basic.nome;
      return `<b>${userBasicName}</b>, muito obrigado :)`;
    },
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("pergunta_algo_mais").index,
      });

      const userPesquisa = useUserStore.getState().pesquisa;

      tagPesquisa(userPesquisa);
    },
  },
  {
    name: "pergunta_algo_mais",
    sender: "bot",
    text: "Se precisar de algo mais, estou aqui!",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("conclusao_fluxo").index,
      });
    },
  },
  {
    name: "pergunta_comentario_especialista",
    sender: "bot",
    text: "Poderia <b>comentar</b> o que podemos melhorar no atendimento?",
    inputType: "userPesquisaComentarios",
    action: () => {
      useBotControlStore.setState({
        currentStep: findStep("pesquisa_finalizada").index,
      });
    },
  },
  {
    name: "pergunta_nota_especialista",
    sender: "bot",
    text: `Qual nota você dá para o <b>atendimento</b> do Time de Humanos?`,
    options: [
      {
        text: "1",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatinsidesales: "1",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pergunta_comentario_especialista").index,
          });
        },
      },
      {
        text: "2",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatinsidesales: "2",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pesquisa_finalizada").index,
          });
        },
      },
      {
        text: "3",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatinsidesales: "3",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pesquisa_finalizada").index,
          });
        },
      },
      {
        text: "4",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatinsidesales: "4",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pesquisa_finalizada").index,
          });
        },
      },
      {
        text: "5",
        action: () => {
          const userData = useUserStore.getState();
          useUserStore.setState({
            ...userData,
            pesquisa: {
              ...userData.pesquisa,
              csatinsidesales: "5",
            },
          });

          useBotControlStore.setState({
            currentStep: findStep("pesquisa_finalizada").index,
          });
        },
      },
    ],
  },
  {
    name: "conclusao_fluxo",
    sender: "bot",
    text: "Até mais!",
  },
];

export default researchSteps;
